import { Component } from "@angular/core";
import { GisDataService } from "../gis-data-upload/gis-data-upload.service";
import { AdminMenusService } from "../admin-sidebar/admin-menus.service";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms"; // Ensure Validators is imported
import { DROPDOWN_OPTIONS } from "./models/layer-history-list.model";
import { ApiserviceService } from "../../../../src/app/apiservice.service";
import { NotificationService } from "../services/notification.service";
import {
  initialSharedModel,
  SharedModel,
} from "../shared/sharedmodel/shared.model";
import { CommonfunctionService } from "../../../../src/app/services/commonfunction.service";
import { HttpClient } from "@angular/common/http";
import { MatDialog } from "@angular/material/dialog";
import { ConfirmDialogBox } from "../confirm-dialog/confirm-dialogbox";

@Component({
  selector: "app-geo-data-download",
  templateUrl: "./geo-data-download.component.html",
  styleUrls: ["./geo-data-download.component.scss"],
})
export class GeoDataDownloadComponent {
  sharedModel: SharedModel = { ...initialSharedModel }; // use common variable from share model file
  geoDataDownloadFormGroup: FormGroup; // FormGroup for handling form data
  totalCount: number = 0; // Total count of some data, initialize to 0
  displayColumns = [
    "id",
    "process_name",
    "file_name",
    "neighbourhood_name",
    "year",
    "geo_type",
    "remark",
    "added_date",
    "added_by",
    // "updated_by",
    "status",
    "log",
    "action",
  ];
  columnsOption: string[] = []; // Changed to an array of strings
  language_list: any = [
    { value: 1, viewValue: "English" },
    { value: 2, viewValue: "Arabic" },
  ];
  defaultColumnList = [
    { value: "gid", viewValue: "gid" },
    { value: "b_no", viewValue: "b_no" },
    { value: "n_name", viewValue: "n_name" },
    { value: "g_name", viewValue: "g_name" },
    { value: "survey_blo", viewValue: "survey_blo" },
    { value: "parcel_no", viewValue: "parcel_no" },
    { value: "house_no", viewValue: "house_no" },
    { value: "geom", viewValue: "geom" },
    { value: "parcel_uid", viewValue: "parcel_uid" },
    { value: "shape_leng", viewValue: "shape_leng" },
    { value: "shape_area", viewValue: "shape_area" },
    { value: "layer_data", viewValue: "layer_data" },
  ];
  geo_type_options:any = [
    { value: 'csv', viewValue: 'File Type CSV' },
    { value: 'shp', viewValue: 'File Type Shp' },
  ]
  searchNeigh: string = "";
  selectedData = []; // Selected data to be processed
  startYear: number; // Variable to store the starting year
  currentYear: number; // Variable to store the current year
  options: any = DROPDOWN_OPTIONS;
  multiple: boolean = true;
  selectedYear = new Date().getFullYear();
  isCommaSeparated: boolean = false; // Set to true or false based on your requirements
  isServerRunning: boolean = false;
    attributesList: any;
  neighbourhoods: any[];
  selectedNeighsDetails: { neigh_name: any; neigh_id: any }[];
  attributesDetailsList: any;
  // Method to get CSS class and color based on status code
  getStatusClass(status: any): { class: string; color: string } {
    // Mapping of status codes to classes and colors
    const StatusClassMap = {
      "-1": { class: "Failed", color: "red" },
      "1": { class: "Running", color: "blue" },
      "2": { class: "Success", color: "green" },
      "0": { class: "waiting", color: "#000" },
    };
    return (
      StatusClassMap[status] || { class: "status-default", color: "black" }
    );
  }

  // Configuration object for button actions and styles
  buttonConfig = {
    log: [
      {
        label: "Log", // Label for the button
        action: (element: any) => this.downloadLog(element), // Function to execute on click
        style: {
          // Styling for the button
          border: "1px solid #e0e8ff",
          color: "#0033cc",
          backgroundColor: "#e0e8ff",
          hover: {
            // Hover styles
            backgroundColor: "#c0d9ff",
          },
          disabled: {
            // Disabled state styles
            color: "gray",
            backgroundColor: "#f0f0f0",
          },
        },
        class: "log-button", // CSS class for additional styling additional styling
      },
    ],
    action: [
      {
        label: "download",
        action: (element) => this.downloadData(element), // Function to accept request
        style: {
          border: "1px solid #24CB6B",
          color: "#ffffff",
          padding: "5px 10px",
          width: "100px",
          backgroundColor: "#24CB6B",
          hover: {
            backgroundColor: "#d9ffd9",
          },
        },
      },
    ],
  };
  geo_data_download_access = {
    GET: false,
    POST: false,
    PATCH: false,
    DELETE: false,
  };
  constructor(
    private active: GisDataService, // Injecting GIS data service
    private menus: AdminMenusService, // Injecting admin menus service
    private fb: FormBuilder,
    private api: ApiserviceService,
    private notify: NotificationService,
    private fnc: CommonfunctionService,
    private http: HttpClient,
    private dialog: MatDialog
  ) {
    this.menus.setActive("geo-data-download"); // Setting the active menu item in admin sidebar
    this.active.setActive(""); // Resetting active state in GIS data service
    this.currentYear = new Date().getFullYear();
    this.startYear = 2009;

    // Initializing the FormGroup with controls
    this.geoDataDownloadFormGroup = new FormGroup({});
  }

  ngOnInit(): void {
    this.geoDataDownloadFormGroup = this.fb.group({
      layer_his_control: ["", Validators.required],
      remark: [""],
      uids: [""],
      column_control: [[]],
      geo_file_type: ["", Validators.required],
      language: [""],
      attributes: [""],
      neighborhood: ["",],
    });

    this.getAllowResourcesApi();
  }

  // Method to handle changes in the UIDs input
  handleUIDInput() {
    this.geoDataDownloadFormGroup
      .get("uids")
      .valueChanges.subscribe((value) => {
        if (value) {
          // Remove spaces before and after commas, and trim the result
          const cleanedValue = value.replace(/\s*,\s*/g, ",").trim();

          // Update the form control with the cleaned, comma-separated string
          this.geoDataDownloadFormGroup
            .get("uids")
            .setValue(cleanedValue, { emitEvent: false });
        }
      });
  }

  // getting allow resources
  getAllowResourcesApi() {
    this.api.getUserRole();
    let body = `user/resource?place_id=${this.api.city_id}&user_id=${this.api.user_id}`;
    this.api.getUmsData(body).subscribe((res: any) => {
      this.api.allowResources = res.data;
      this.getAllowResource();
      this.getRequestdata();
      this.getNeighbourhoods();
    });
  }

  getAllowResource() {
    this.geo_data_download_access = this.fnc.checkResourceAccess(
      "geo_data_download",
      false
    );
  }
  // Handles the chosen year for the date picker
  handleYearSelected(year: number) {
    // if(!this.geo_data_download_access.GET){
    //   this.notify.notify("Access declined: You are not authorized for operation","warn")
    //   return
    // }
    console.log("Selected Year:", year); // Log the selected year to the console
    this.selectedYear = year;
    this.getRequestdata();
  }

  getGeoData() {
    let url = ``; // Placeholder for building a URL for data fetching
  }
  downloadData(element) {
    if (!this.geo_data_download_access.PATCH) {
      this.notify.notify(
        "Access declined: You are not authorized for operation",
        "warn"
      );
      return;
    }
    if (element.status == 0 || element.status == 1) {
      this.notify.notify(
        "File generation is in progress. Please wait and retry later!",
        "warn"
      );
      return;
    }
    window.open(element.file_path, "_blank");
  }

  downloadLog(element) {
    if (!this.geo_data_download_access.PATCH) {
      this.notify.notify(
        "Access declined: You are not authorized for operation",
        "warn"
      );
      return;
    }
    window.open(element.logfile, "_blank"); // Open the log URL in a new browser tab
  }
  // Handles form submission
  submit() {
    if (!this.geo_data_download_access.POST) {
      this.notify.notify(
        "Access declined: You are not authorized for operation",
        "warn"
      );
      return;
    }
    // if(!this.isServerRunning){
    //   this.notify.notify("The server must be running to perform the calculation. Please start the server and try again!", "warn");
    //   return
    // }
    if (!this.geoDataDownloadFormGroup.value.geo_file_type) {
      this.notify.notify("Oops! Geo Type is required to proceed.", "warn");
      return;
    }
    // Open confirmation dialog
    const dialogRef = this.dialog.open(ConfirmDialogBox, {
      width: "350px",
      data: {
        message: "Are you sure you want to proceed?",
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result == "YES") {
        this.formSubmit();
      }
    });
  }
  // Perform the actual form submission logic
  formSubmit() {
    this.handleUIDInput();
    const url = `geo-data-list`;
    const cleanedColumns = (this.geoDataDownloadFormGroup.value.column_control || [])
  .filter(col => col !== 'layer' && col !== 'layer_data')
  .join(',');
    const body: any = {
      process_name: this.geoDataDownloadFormGroup.value.layer_his_control,
      added_by: this.api.user_id,
      remark: this.geoDataDownloadFormGroup.value.remark,
      year: this.selectedYear,
      uids: this.geoDataDownloadFormGroup.value.uids,
      columns: cleanedColumns,
      // geo_type: this.geoDataDownloadFormGroup.value.geo_file_type,
      // columns: this.geoDataDownloadFormGroup.value.column_control.join(','),
      geo_type:this.geoDataDownloadFormGroup.value.geo_file_type,
      neighbourhood_details:this.selectedNeighsDetails
    };
    const layer = this.geoDataDownloadFormGroup.value.layer_his_control;
    const columns = this.geoDataDownloadFormGroup.value.column_control || [];

    const isLayerMatch = layer === "parcels_his" || layer === "streets_his";
    const hasLayerColumns =
      Array.isArray(columns) &&
      (columns.includes("layer") || columns.includes("layer_data"));
    if (isLayerMatch && hasLayerColumns) {
         // Data types to check for numeric fields
    const numericTypes = ["numeric", "decimal-input", "integer"];
    // Output buckets
    const layer_attributes_common: string[] = [];
    const unmatchedAttributes: string[] = [];
      const selectedAttributes: string[] = this.geoDataDownloadFormGroup?.value?.attributes || [];
      selectedAttributes.forEach((attrName) => {
     const matchedAttr = this.attributesDetailsList.find(attr => attr.attribute_name === attrName);

  if (matchedAttr && numericTypes.includes(matchedAttr.data_type?.toLowerCase().trim())) {
    layer_attributes_common.push(attrName);
  } else {
    unmatchedAttributes.push(attrName);
  }
})
      const languageId = this.geoDataDownloadFormGroup.value.language;
      console.log(languageId, "language");

      if (languageId === null || languageId === undefined || languageId === '') {
        this.notify.notify("Language ID is required.", "warn");
        return; // Stop further execution
      }

      // Add to body
      body.language_id = languageId;
      body.layer_attributes_common = layer_attributes_common.join(",");
      body.layer_attributes = unmatchedAttributes.join(",");
    }
    this.api.postGesData(url, body).subscribe({
      next: (res: any) => {
        if (res.status === 200) {
          this.getRequestdata();
          this.geoDataDownloadFormGroup.patchValue({
            remark: "",
            uids: "",
          });
        } else {
          this.notify.notify(res.message, "warn");
        }
      },
      error: (err: any) => {
        console.error(err);
      },
    });
  }
  // Fetch columns dynamically from the API
  getColumns(processname: string) {
    console.log(processname, "processname");

    const url = `/get-columns?process_name=${processname}`;
    this.api.getGesData(url).subscribe({
      next: (res: any) => {
        if (res.status === 200) {
          // Set column options directly from the API response (array of strings).
          this.columnsOption = res.data.map((col: string) => ({
            value: col,
            viewValue: col,
          }));

          if (processname == "parcels_his") {
            // Match and set default selected columns
            const defaultValues = this.defaultColumnList
              .map((d) => d.value)
              .filter((value) => res.data.includes(value)); // check against raw strings from API
            this.geoDataDownloadFormGroup
              .get("column_control")
              ?.setValue(defaultValues);
          }

          if (processname === "streets_his") {
            const defaultValues = res.data;
            this.geoDataDownloadFormGroup
              .get("column_control")
              ?.setValue(defaultValues);
          }
        } else {
          this.notify.notify(res.message, "warn");
        }
      },
      error: (err) => {
        console.error(err);
        this.notify.notify("Error fetching columns", "warn");
      },
    });
  }

  getNeighbourhoods() {
    this.neighbourhoods = [];
    let url = `neighbourhoods/json`;
    if (this.selectedYear) {
      url += `?year=${this.selectedYear}`;
    }
    this.api.getGpsData(url).subscribe({
      next: (data: any) => {
        if (data.length) {
          this.neighbourhoods = data;
        }
      },
      error: () => {},
    });
  }
  onSelectionChange(event) {
     const index = 3;
    const columnToAdd = "neighbourhood_name";
    this.geoDataDownloadFormGroup.controls["layer_his_control"].setValue(event);
    // Reset the column control when the layer is changed
    this.geoDataDownloadFormGroup.controls["column_control"].setValue([]);

    // First, remove it if it exists (to avoid duplicates or handle the else condition)
    const existingIndex = this.displayColumns.indexOf(columnToAdd);
    if (existingIndex !== -1) {
      this.displayColumns.splice(existingIndex, 1);
    }

    // Now, insert only if the event matches
    if (event === "parcels_his") {
      this.displayColumns.splice(index, 0, columnToAdd);
    }
    this.getRequestdata();
    this.getColumns(this.geoDataDownloadFormGroup.value.layer_his_control);
    // Clear previous column options
    this.columnsOption = []; // Reset columns options

    // Fetch new columns based on the selected layer
    this.getColumns(event);
    if (
      this.geoDataDownloadFormGroup.value.layer_his_control == "parcels_his"
    ) {
      this.gisAttributes("parcel");
    }

    if (
      this.geoDataDownloadFormGroup.value.layer_his_control == "streets_his"
    ) {
      this.gisAttributes("street");
    }
  }
  getRequestdata() {
    // if(!this.geo_data_download_access.GET){
    //   this.notify.notify("Access declined: You are not authorized for operation","warn")
    //   return
    // }
    let url = `geo-data-list?process_name=${this.geoDataDownloadFormGroup.value.layer_his_control}&limit=${this.sharedModel.limit}&offset=${this.sharedModel.offset}&year=${this.selectedYear}&added_by=${this.api.user_id}&is_count=true`;
    this.sharedModel.loader = true;
    this.api.getGesData(url).subscribe({
      next: (res: any) => {
        if (res.status == 200) {
          this.sharedModel.loader = false;
          this.notify.notify(res.message, "success");
          // Process each item to add 'neighbourhood' string
          this.selectedData = res.data.map((item: any) => {
            const neighbourhoodNames = item?.parameter?.neigh_details
              ? item?.parameter?.neigh_details
                  .map((n: any) => n.neigh_name)
                  .join(", ")
              : "";
            return {
              ...item,
              neighbourhood_name: neighbourhoodNames,
            };
          });

          this.totalCount = res.count;
        } else {
          this.notify.notify(res.message, "warn");
          this.sharedModel.loader = false;
          this.selectedData = [];
          this.totalCount = 0;
        }
      },
      error: (err) => {
        this.sharedModel.loader = false;
        console.log(err);
        this.selectedData = [];
        this.totalCount = 0;
      },
    });
  }
  sync() {
    this.getRequestdata(); // Fetch data for the new page
  }

  // Method to handle pagination changes
  onPageChange(event: any) {
    this.sharedModel.limit = event.limit; // Update limit based on pagination event
    this.sharedModel.offset = event.offset; // Update offset based on pagination event
    this.getRequestdata(); // Fetch data for the new page
  }
  checkServerStatus(event) {
    this.isServerRunning = event;
  }
  gisAttributes(layer) {
    let url = `${layer}/attributes-entity?&status=1`;
    this.api.getGmsData(url).subscribe((res: any) => {
      this.attributesDetailsList = res?.data
      this.attributesList = res.data.map((attr) => ({
        value: attr.attribute_name,
        viewValue: attr.attribute_name,
      }));
    });
  }
  isHistoricalLayerSelected(): boolean {
    const layer = this.geoDataDownloadFormGroup.value.layer_his_control;
    const columnControl = this.geoDataDownloadFormGroup.value.column_control;

    const isLayerMatch = layer === "streets_his" || layer === "parcels_his";
    const columns = Array.isArray(columnControl)
      ? columnControl.map((c) => c.trim())
      : [];

    const hasLayerColumns =
      columns.includes("layer") || columns.includes("layer_data");

    return isLayerMatch && hasLayerColumns;
  }

  selectedNeigh(event: string[]) {
    console.log(event, "event");
    console.log(this.neighbourhoods, "neighbourhoods");

    const result = this.neighbourhoods
      .filter((neigh) => event.includes(neigh.neigh_uid))
      .map((neigh) => ({
        neigh_name: neigh.neigh_name,
        neigh_id: neigh.neigh_id,
      }));
    this.selectedNeighsDetails = result;
  }
}
